
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientSearch',
  data () {
    return {
      loaded: false,
      loading: false,
      patientResult: [
        {
          name: 'Strawberry Shortcake Jamz',
          birthdate: '01 Jan 1980',
          age: '20',
          location: 'Ward 12',
          hrn: 332211
        },
        {
          name: 'Butter Cookie Jamz',
          birthdate: '01 Jan 1981',
          age: '15',
          location: 'Ward 15',
          hrn: 332212
        },
        {
          name: 'Peach Blush Jamz',
          birthdate: '01 Jan 1981',
          age: '15',
          location: 'Ward 15',
          hrn: 332212
        }
      ]
    }
  },
  methods: {
    onClick () {
      this.loading = true

      setTimeout(() => {
        this.loading = false
        this.loaded = true
      }, 2000)
    },
    selectPatient (patient) {
      this.$emit('selectedPatient', patient)
    }
  },
})

